
<template>
  <div class="login_bj">
    <div class="login_kuan">
      <div class="login_tishi_dv">图床后台系统</div>
      <div class="logon_input_dv">
        <div class="top_img"><img
            src="~@/assets/img/Snipaste_2020-08-24_12-23-11.png"
            alt=""
          ></div>
        <div
          class="username_dv input_dv"
          :class="{'border_color':isfocusUsername}"
        >
          <span class="icon iconfont icon-youxizhanghao"></span>
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            @focus="focusUsernameFun"
          ></el-input>
        </div>
        <div
          class="password_dv input_dv "
          :class="{'border_color':isfocusPassw}"
        >
          <span class="icon iconfont icon-mima"></span>
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="请输入密码"
            @focus="focusPasswordFun"
          ></el-input>
        </div>
        <div
          class="btn_login"
          @click="login"
        >登陆</div>
        <div class="wangji_password">忘记密码？</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   data() {
      return {
         isfocusPassw: false,
         isfocusUsername: false,
         token: null,
         loginForm: {
         username: "",
         password: "",
         },
         checked: false,
      };
   },
   created() {
      //初始化  head标签 侧边栏 面包屑
      window.localStorage.clear();
      this.$store.commit('initCacheFun')
      //this.getToken();
   },
   methods: {
      //密码获取焦点
      focusPasswordFun() {
         this.isfocusPassw = true;
         this.isfocusUsername = false;
      },
      //用户名获取焦点
      focusUsernameFun() {
         this.isfocusUsername = true;
         this.isfocusPassw = false;
      },
      //从服务器获取游客token
      getToken() {
         this.https(this.apiList.getToken).then(
         (response) => {
            let { data: resp } = response;
            if (resp.code != "000") return false;
            // 保存token
            localStorage.setItem(this.api.AUTH_TOKEN_FLAG, resp.data.token);
         });
      },
      login() {
         //非空判断
         if (this.loginForm.username == "" || this.loginForm.password == "") {
            this.$message("请输入正确的账号密码");
            this.loginForm.password = "";
            return;
         }
         //参数
         let fromData = {
            username : this.loginForm.username,
            password : this.loginForm.password,
         }
         this.https(this.apiList.login, fromData).then((response) => {
            if (response.data.code == "000") {
              // 保存token
            localStorage.setItem(this.api.AUTH_TOKEN_FLAG,response.data.data.token);
               // 设置vuex登录状态为true.
               this.$store.dispatch("userLogin", true);
               // 获取管理员信息
               this.getAdminInfo();
            } else {
               this.$message.warning(response.data.msg);
            }
         });
      },
      // 获取管理员信息
      getAdminInfo() {
         this.https(`${this.apiList.getAdminInfo}`).then(
         (res) => {
            let resp = res.data;
            let adminInfo = resp.data[0];
            
            // 存储客服信息
            this.$store.commit("setUser", adminInfo);
            this.$message.success("登录成功");
            // 跳转首页
            this.$router.push({ name: "index2" });
         }
         );
      },
   },
};
</script>

<style lang="scss">
.login_bj {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/u0.jpg") no-repeat;
  .login_kuan {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -240px;
    width: 800px;
    height: 480px;
    border: none;
    border-radius: 5px;
    background: url("~@/assets/img/u21.jpg") no-repeat;
    .logon_input_dv {
      position: absolute;
      right: 40px;
      top: 50px;
      width: 340px;
      height: 388px;
      background-color: #fff;
      border-radius: 20px;
      .top_img {
        margin-top: 60px;
      }
      .border_color {
        border-bottom: 1px solid #4f7da4 !important;
      }
      .input_dv {
        display: flex;
        width: 242px;
        height: 40px;
        line-height: 40px;
        margin: 25px auto 0;
        border-bottom: 1px solid #ccc;
        padding-bottom: 1px;
        span {
          font-size: 18px;
          color: #4f7da4;
          margin-right: 10px;
        }
        input {
          outline: none;
          border: none;
          color: #4f7da4;
        }
      }
      .btn_login {
        margin: 30px auto 0;
        width: 266px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        text-align: center;
        background-color: rgba(79, 125, 164, 1);
        border-radius: 5px;
        &:hover {
          background: linear-gradient(
            0deg,
            rgba(79, 125, 164, 1) 5%,
            rgba(129, 211, 248, 1) 100%
          );
        }
      }
      .wangji_password {
        width: 100%;
        text-align: center;
        font-family: "思源黑体 CN";
        font-weight: 400;
        font-style: normal;
        color: #4f7da4;
        line-height: 14px;
        font-size: 14px;
        margin-top: 20px;
        &:hover {
          color: rgb(129, 211, 248);
        }
      }
    }
    .login_tishi_dv {
      position: absolute;
      left: 0;
      top: 50px;
      width: 152px;
      height: 20px;
      text-align: right;
      border-left: 4px solid #fff;
      font-family: "思源黑体 CN";
      font-weight: 400;
      font-style: normal;
      font-size: 20px;
      color: #ffffff;
      line-height: 20px;
    }
  }
}
</style>
